import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Tag as Tag$1, TagLabel, TagCloseButton } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';
var Tag = function Tag(_ref) {
  var closeClick = _ref.closeClick,
    onClick = _ref.onClick,
    variant = _ref.variant,
    colorScheme = _ref.colorScheme,
    tagLabel = _ref.tagLabel,
    isClosable = _ref.isClosable,
    isRound = _ref.isRound,
    size = _ref.size,
    children = _ref.children,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon;
  /**
   * DOM
   */

  return /*#__PURE__*/React.createElement(Tag$1, _extends({
    variant: variant,
    size: size,
    colorScheme: colorScheme,
    "data-object-type": "tag"
  }, isRound && {
    rounded: 'full'
  }, onClick && {
    onClick: onClick,
    as: 'button',
    cursor: 'pointer'
  }), !!leftIcon && /*#__PURE__*/React.createElement(Icon, leftIcon), !!tagLabel && /*#__PURE__*/React.createElement(TagLabel, null, tagLabel), children, !!rightIcon && /*#__PURE__*/React.createElement(Icon, rightIcon), !!isClosable && /*#__PURE__*/React.createElement(TagCloseButton, _extends({
    onClick: closeClick
  }, isRound && {
    rounded: 'full'
  })));
};
Tag.displayName = "Tag";
export { Tag };